"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefBuilder = exports.PathBuilder = void 0;
const utils_1 = require("../utils");
/**
 * Creates a path validation function factory for a given Firestore mapper type.
 * This higher-order function allows generating type-safe path accessors
 * for different Firestore data structures, ensuring that only valid paths
 * defined in the mapper are used.
 *
 * @template Mapper - The specific Mapper type, which must extend Firestore.
 * @returns A function that takes a path (a key of `Mapper`) and returns it,
 *          enforcing type safety at compile time.
 *
 * @example
 * interface Mapper extends Firestore {
 *   'users/{userId}': UserData;
 *   'products/{productId}': ProductData;
 * }
 *
 * const Path = PathBuilder<Mapper>();
 *
 * const userPath = Path('users/{userId}'); // Correctly typed
 * // const invalidPath = Path('nonExistentPath'); // Compile-time error
 */
const PathBuilder = () => 
/**
 * Get a document or collection path from the list of known paths.  This is
 * useful to ensure that the path being referenced is known and can help
 * surface build-time errors.
 */
(path) => path;
exports.PathBuilder = PathBuilder;
const checkPath = (path) => {
    const parity = (path.replace(/^\/+|\/+$/g, "").split("/").length % 2 === 0 ? "even" : "odd");
    return parity;
};
/**
 * Generate a new function for building document and collection references
 * from the paths and data types defined in `Mapper`.
 */
const RefBuilder = (props) => {
    return (path, ...[params]) => {
        //
        // TODO: How to remove ts-ignore??
        //
        const truePath = (0, utils_1.enumKeys)(params).reduce((path, key) => {
            // @ts-ignore
            return path.replace(`{${key}}`, params === null || params === void 0 ? void 0 : params[key]);
        }, path);
        const parity = checkPath(path);
        if (parity === "even") {
            // @ts-ignore
            return props.doc(props.getFirestore(), truePath);
        }
        // @ts-ignore
        return props.collection(props.getFirestore(), truePath);
    };
};
exports.RefBuilder = RefBuilder;
//# sourceMappingURL=refs.js.map